<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="addWarehouse()" v-if="permission.addWarehouse">{{
                    permission.addWarehouse
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="gotoTransWarehouse()" v-if="permission.trans">查看调拨单</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="gotoInOutRecord()" v-if="permission.InOutRecords">{{ permission.InOutRecords }}</el-button>
                <el-button size="small" type="warning" class="search-btn" @click="gotoLimitSets()" v-if="permission.limitSets">各仓上下限设置</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">仓库</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Keyword" v-filter-special-char="searchData.Keyword" placeholder="仓库名称或编号"></el-input>
                <div class="search-name">仓库状态</div>
                <el-select v-model="searchData.State" class="search-item" size="small" placeholder="请选择">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">创建时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @cell-dblclick="handleDBClick">
                <el-table-column show-overflow-tooltip width="250px" prop="Name" label="仓库名称"
                    >
                    <template slot-scope="scope">
                        <img width="23px" height="23px" src="../../../assets/images/webcam.png" v-if="scope.row.ismonitordevices != null && permission.camera" alt @click="MonitorDevices(scope.row)"/>
                        <span v-if="scope.row.ismonitordevices != null && permission.camera" v-html="'\u00a0\u00a0'"></span>
                        {{ scope.row.Name }}
                         <span style="color: #8492a6" v-if="scope.row.Type == 1"> (前置仓)</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="200px" prop="Code" label="仓库编号"></el-table-column>
                <el-table-column show-overflow-tooltip label="所在省市">
                    <template slot-scope="scope">{{ scope.row.Province }}{{ scope.row.City }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Address" label="地址"></el-table-column>
                <el-table-column width="100" show-overflow-tooltip prop="MainSto" label="是否主仓"></el-table-column>
                <el-table-column width="120" show-overflow-tooltip prop="ZoneCount" label="关联区域数量"></el-table-column>
                <el-table-column width="100" show-overflow-tooltip label="状态">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column width="160" show-overflow-tooltip prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.stoTitleSet"
                                :title="permission.stoTitleSet"
                                size="mini"
                                type="text"
                                style="color: #c89932"
                                @click="setTitles(scope.row)"
                                >{{ permission.stoTitleSet }}</el-button
                            >
                            <el-button
                                v-if="permission.toBeShippedManage && scope.row.Type == 0"
                                title="待发区"
                                size="mini"
                                type="text"
                                style="color: #c89932"
                                @click="gotoShippedZoneManage(scope.row)"
                                >{{ permission.toBeShippedManage }}</el-button
                            >
                            <el-button
                                v-if="permission.zoneManage && scope.row.Type == 0"
                                title="管理区域"
                                size="mini"
                                type="text"
                                style="color: #c89932"
                                @click="gotoZoneManage(scope.row)"
                                >{{ permission.zoneManage }}</el-button
                            >
                            <el-button
                                v-if="permission.editPosition && scope.row.Type == 0"
                                title="管理仓位"
                                size="mini"
                                type="text"
                                style="color: #c89932"
                                @click="gotoWarePosition(scope.row)"
                                >{{ permission.editPosition }}</el-button
                            >
                            <el-button
                                v-if="permission.editPosition && scope.row.Type == 1"
                                title="查看仓位"
                                size="mini"
                                type="text"
                                style="color: #c89932"
                                @click="gotoWarePosition(scope.row)"
                                >查看仓位</el-button
                            >
                            <el-button v-if="permission.editWarehouse && scope.row.Type == 0" title="编辑" size="mini" type="text" @click="editWarehouse(scope.row)">{{
                                permission.editWarehouse
                            }}</el-button>
                            <el-button
                                v-if="permission.delWarehouse && scope.row.Type == 0"
                                title="删除"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delWarehouse(scope.row)"
                                >{{ permission.delWarehouse }}</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!--    新增/编辑仓库    -->
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="editVisible" width="800px">
            <div class="dialog-content" v-if="editVisible">
                <warehouseEdit :WarehouseId="WarehouseId" @closeDialog="closeEdit"></warehouseEdit>
            </div>
        </el-dialog>
        <!--    查看仓库    -->
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
        <!--    查看仓库存放的货物信息    -->
        <el-dialog :close-on-click-modal="false" title="仓库信息" :visible.sync="showVisible" width="1200px">
            <div class="dialog-content" v-if="showVisible">
                <warehouseGoodShow :WarehouseId="WarehouseId"></warehouseGoodShow>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="'【' + WarehouseName + '】' + '单头设置'" :visible.sync="showSetVisible" width="1000px">
            <div class="dialog-content" v-if="showSetVisible">
                <stoTitleSets :WarehouseId="WarehouseId"></stoTitleSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import warehouseEdit from '@/components/business/goods/warehouseEdit';
import stoTitleSets from '@/components/business/goods/stoTitleSets';
import warehouseGoodShow from '@/components/business/goods/warehouseGoodShow';
import timePicker from '@/components/common/timePicker';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        warehouseEdit,
        warehouseGoodShow,
        timePicker,
        breadcrumb,
        elTableColumn,
        stoTitleSets
    },
    name: '',
    data() {
        return {
            timeVisible: false,
            stateList: [
                { Value: '', Text: '全部' },
                { Value: '0', Text: '正常使用' },
                { Value: '1', Text: '停用' }
            ],
            WarehouseId: '',
            WarehouseName: '',
            dialogTitle: '仓库信息',
            editVisible: false,
            showVisible: false,
            searchData: {
                Keyword: '',
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            showSetVisible: false
        };
    },
    mounted() {
        this.getTableData();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('warehouse');
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常使用';
            } else if (value == 1) {
                return '停用';
            }
        }
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        gotoTransWarehouse() {
            this.$router.push(`/inventoryManage/transWarehouse`);
        },
        gotoInOutRecord() {
            this.$router.push(`/inventoryManage/InOutRecords`);
        },
        gotoLimitSets(){
            this.$router.push(`/inventoryManage/limitSets`);
        },
        closeEdit(update) {
            this.WarehouseId = '';
            this.editVisible = false;
            if (update) {
                this.getTableData();
            }
        },
        gotoWarePosition(row) {
            this.$router.push(`/inventoryManage/warePosition?id=${row.WarehouseId}&warehouse=${row.Name}`);
        },
        gotoShippedZoneManage(row) {
            this.$router.push(`/inventoryManage/toBeShippedZoneManage?id=${row.WarehouseId}&warehouse=${row.Name}`);
        },
        gotoZoneManage(row) {
            this.$router.push(`/inventoryManage/zoneManage?id=${row.WarehouseId}&warehouse=${row.Name}`);
        },
        editWarehouse(row) {
            this.WarehouseId = row.WarehouseId;
            this.editVisible = true;
        },
        addWarehouse() {
            this.WarehouseId = '';
            this.editVisible = true;
        },
        // 删除仓库
        delWarehouse(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该仓库吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpWarehouse/DeleteEnterpriseWarehouse?id=${row.WarehouseId}`,
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.getTableData();
                            that.$util.successMsg('删除成功');
                        })
                        .catch(() => {});
                }
            });
        },
        //跳转摄像头页面
        MonitorDevices(row){
            this.$router.push(`/inventoryManage/monitorDevices?id=${row.WarehouseId}`);
        },
        resetSearch() {
            this.searchData = {
                Keyword: '',
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpWarehouse/GetEnterpriseWarehouseList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.WarehouseId = event.WarehouseId;
                this.showVisible = true;
            }
        },
        setTitles(row) {
            if (row) {
                this.WarehouseId = row.WarehouseId;
                this.WarehouseName = row.Name;
                this.showSetVisible = true;
            }
        }
    }
};
</script>
